/*
 * Public API Surface of ng-otp-input
 */

export * from './lib/ng-otp-input.module';
export {Config as NgOtpInputConfig} from './lib/models/config';
export * from './lib/components/ng-otp-input/ng-otp-input.component';